export const onPreRouteUpdate = () => {
  setTimeout(() => {
      document.getElementById("loadOverlay").style.display = "none"
  }, 2000)
}